import guide from 'config/guide';

import { apiURLNew, callAPI } from 'api/main';

interface IParams {
  email: string;
  lang: string;
}

export default async ({ email, lang }: IParams): Promise<any> => {
  try {
    const res = await callAPI({
      url: `${apiURLNew}/user/public/auth/v1/send-token`,
      method: 'POST',
      isLegacy: false,
      params: {
        guid: guide,
        credential: email,
        lang,
      },
    });

    const data = res.request;

    if (data) {
      return data;
    }

    null;
  } catch (ex) {
    return null;
  }
};
